import * as React from 'react';
import styled from 'astroturf/react';
import { Icon } from './Icon';

interface Props {
  text: string | React.ReactNode;
  icon?: string;
  iconSize?: number;
  color?: string;
  backgroundColor?: string;
  height?: string;
  style?: React.CSSProperties;
}

const Container = styled.div`
  color: var(--text-white, #fff);

  @import 'stylesheets/design_system/font';
  @include body__small;

  display: inline-flex;
  flex-grow: 0 !important;
  height: 28px;
  padding: 0px var(--spacing-xs-8, 8px);
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: var(--corner-radius-radius-md, 8px);
  background-color: var(--primary-brand, #0645b1);
  text-decoration: none !important;
`;

// A small text label with a colored background to highlight or draw attention to details.
const Badge: React.FC<Props> = ({
  text,
  icon,
  iconSize = 20,
  color,
  backgroundColor,
  height,
  style = {},
}) => {
  const iconView = icon ? <Icon name={icon} size={iconSize} /> : null;

  return (
    <Container style={{ ...style, height, color, backgroundColor }}>
      {iconView ? iconView : null}
      {text}
    </Container>
  );
};

export default Badge;
